export function darkenColor(color: string, isDark: boolean, amount = 0.5): string {
	const canvas = document.createElement('canvas');
	canvas.width = canvas.height = 1;
	const ctx = canvas.getContext('2d');
	if (!ctx) { return color; }
	ctx.fillStyle = color;
	ctx.fillRect(0, 0, 1, 1);
	const [r, g, b] = ctx.getImageData(0, 0, 1, 1).data;
	if (isDark) {
		return `rgb(${Math.round(r + (255 - r) * amount)}, ${Math.round(g + (255 - g) * amount)}, ${Math.round(b + (255 - b) * amount)})`;
	}
	return `rgb(${Math.round(r * (1 - amount))}, ${Math.round(g * (1 - amount))}, ${Math.round(b * (1 - amount))})`;
}

export function getHighlightColor(i: number) {
	return `hsla(${(i * 54 + 220) % 360}, 30%, 50%, 0.5)`;
}

export function getWebHighlightColor(i: number) {
	return `hsla(${(i * 54 + 30) % 360}, 40%, 50%, 0.5)`;
}
